import { render, staticRenderFns } from "./ColoredNumber.vue?vue&type=template&id=39a8df58&"
import script from "./ColoredNumber.vue?vue&type=script&lang=js&"
export * from "./ColoredNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports